import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './index.scss';


class Button extends Component {
  render() {
    const{ text,linkTo, clickEvent } = this.props;

    return (
        <Link className="post-btn" to={linkTo  || `#`}>
          {text}
        </Link>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/pure.js